import { actions } from '../../../reducers/assignment.reducer'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'
import { submissionActions } from '../../../slices/submission.slice'

export const onMoveGroupSubmissionsQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    const response = await queryFulfilled
    dispatch(actions.setClusters(response.data))
    dispatch(submissionActions.resetSelectedSubmissionIds())
    dispatch(actions.setShowMoveSelectedFilesToAnotherGroupModal(false))
    if (arg.newGroupName) openNotificationWithIcon('success', `Created <code>${arg.newGroupName}</code> group`)
}

export const onDeleteGroupQueryStarted = async (arg, { getState, dispatch, queryFulfilled }) => {
    await queryFulfilled
    const _clusters = getState().assignment.clusters.filter(cluster => cluster.cluster_id !== arg.groupId)
    dispatch(actions.setClusters(_clusters))
}
